import { Location } from '@crimsontide/core/client/interfaces'
import DotNetObject = DotNet.DotNetObject;

let dotNetObj: DotNetObject;

export const LocationService = (() => {
  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getLocations = async (siteIds: string[], locationId?: string): Promise<Location[]> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<Location[]>('GetCascadingAsync', siteIds, locationId);
    } else {
      throw 'Location DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getLocations,
  };
})();
